import { Component, Input } from '@angular/core';
import { getSubTags, hasTag } from '../../util/tag-utils';
import { IConditionalSection } from '../../shared/models/condition-section.model';

@Component({
  selector: 'app-credit-cards',
  templateUrl: './credit-cards.component.html',
  styleUrls: ['./credit-cards.component.scss']
})
export class CreditCardsComponent implements IConditionalSection {

  @Input() tags: any[];
  hasTag = hasTag;

  get hasContent(): boolean {
    return getSubTags(this.tags, 'Credit Cards::').length > 0;
  }

  get nonAOPAMasterCardCreditCards(): String[] {
    const result: String[] = [];
    for (const currentTag of this.tags) {
      if (currentTag.tagName.startsWith('Credit Cards::') &&
        !currentTag.tagName.includes('AOPA Mastercard')) {
        result.push(currentTag.displayName);
      }
    }
    return result.sort();
  }
}
